import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8081/api/codetable'
// http://192.168.242.74:8180/swagger-ui.html
const baseUrl = config.apiDomain.ALI + '/ext/esign/identificationTool/'
const extBaseUrl = config.apiDomain.ALI + '/ext/tool/' // different OSS

const buildIdLinkUrl = baseUrl + 'buildIdentificationLink/' // Build eSign pdf OAuth info. ** is the base64 encoded call back URL after eSignOuth authorized to sign.
const getIdLinkUrl = baseUrl + 'getIdentificationLink'
const updatePdfAndBuildIdLinkUrl = baseUrl + 'updatePdfAndBuildIdentificationLink' // for tasklist

const extSignUrl = extBaseUrl + 'api/identificationTool/sign?code='
const updatePdfsAndBuildBatchIdLinkUrl = baseUrl + 'updatePdfsAndBuildBatchIdentificationLink'
const authorizeUrl = baseUrl + 'authorize?'
// const batchSignAndCompleteUrl = baseUrl + 'batchIdentificationSignAndComplete/' // auth_code
// const WAIT_FOR_CHECKING_SINGING_CART = 1 * 1000

// /{businessCode} Start a workflow by automatically finding next staff
// /{businessCode}/{assignedToStaffCode}  Start a workflow
// const startWorkflowUrl = baseUrl + 'startWorkflow/'

Axios.defaults.headers.timeout = 8000

export default {
  getIdLinkUrl,
  updatePdfAndBuildIdLinkUrl,
  extSignUrl,
  updatePdfsAndBuildBatchIdLinkUrl,
  // batchSignAndCompleteUrl,

  buildIdLink (cb, callBackUrl) {
    Axios.get(buildIdLinkUrl + callBackUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getIdLink (cb, form) {
    Axios.post(getIdLinkUrl, form).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  updatePdfsAndBuildBatchIdLink (cb, data) {
    Axios.post(updatePdfsAndBuildBatchIdLinkUrl, data).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getAuthorizeUrl (cb, params) {
    return new Promise((resolve, reject) => {
      Axios.post(authorizeUrl + params).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error.response)
        }
      )
    })
  }

  // batchSignAndComplete (cb, businessCode, authCode, data) {
  //   Axios.post(batchSignAndCompleteUrl + businessCode + '/' + authCode, data).then(
  //     response => {
  //       cb(response)
  //     },
  //     error => {
  //       cb(error.response)
  //     }
  //   )
  // }

}
